import { render, staticRenderFns } from "./suitch-stone-modes.vue?vue&type=template&id=4e3c1f5d&scoped=true&"
import script from "./suitch-stone-modes.vue?vue&type=script&lang=js&"
export * from "./suitch-stone-modes.vue?vue&type=script&lang=js&"
import style0 from "./suitch-stone-modes.vue?vue&type=style&index=0&id=4e3c1f5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c1f5d",
  null
  
)

export default component.exports